import React, { useState, useEffect } from "react";
import { Header } from "./components/Header";
import { SectionsSidebar } from "./components/SectionsSidebar";
import { KPIList } from "./components/KPIList";
import { DetailPanel } from "./components/DetailPanel";
import heartLoading from "../../../../assests/heartLoading.gif";
import axios from "axios";


const Main = ({ productName }) => {
  const [data, setData] = useState(null);
  const [selectedSections, setSelectedSections] = useState(data?.selectedSection || []);
  const [selectedKpiTypes, setSelectedKpiTypes] = useState(data?.selectedKpiType || []);
  const [activeKPI, setActiveKPI] = useState("");
  const [kpiSearch, setKpiSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [kpiTypeOption, setKpiTypeOption] = useState(null)

  const filteredKpis = data?.kpiList?.filter(kpi =>
    kpi.toLowerCase().includes(kpiSearch.toLowerCase())
  );

  const handleSectionsChange = (sections) => {
    setSelectedSections(sections);
  };

  const handleKpiTypesChange = (types) => {
    setSelectedKpiTypes(types);
  };

  const handleKPIChange = (kpi) => {
    setActiveKPI(kpi);
    fetchData(kpi)
  };
  const onApplyFilters = () => {
    fetchData();
  };
  const clearFilter = () => {
    setSelectedSections([]);
    setSelectedKpiTypes([]);
    setActiveKPI("");
    fetchData("clear_data")

  }

  const fetchData = async (kpi) => {
    try {
      setLoading(true);

      const kpiType = selectedKpiTypes.map((type) => type.name);

      const payload = {
        sections: kpi === "clear_data" ? [] : selectedSections.map((s) => s.id),
        kpiType: kpi === "clear_data" ? [] : kpiType,
        kpiName: kpi === "clear_data" ? "" : kpi,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/kpi/view/${productName}`,
        payload
      );

      setData(response?.data);
      setActiveKPI(response?.data?.selectedKpi);
      setKpiTypeOption(response?.data?.kpiType);
    } catch (e) {
      console.error("Error fetching data:", e);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchData("clear_data");
  }, []);

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
        <div className="bg-white rounded-lg shadow-xl w-4/5 h-[90vh] overflow-hidden flex items-center justify-center">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <img
              src={heartLoading}
              alt="Loading..."
              style={{ width: "120px", height: "120px" }}
            />
            <span
              style={{
                color: "#374151",
                fontSize: "20px",
                fontWeight: "500",
              }}
            >
              Hang tight! The resources are loading...
            </span>
          </div></div>
      </div>

    );
  }


  return (
    data?.sections?.length > 0 ? (
      <div className=" flex flex-col h-[714px] bg-gray-50 border border-gray-300 ">
        <div className="flex flex-1 overflow-hidden">
          <SectionsSidebar
            sections={data?.sections}
            selectedSections={selectedSections}
            onSectionsChange={handleSectionsChange}
            kpiTypes={data?.kpiType}
            selectedKpiTypes={selectedKpiTypes}
            onKpiTypesChange={handleKpiTypesChange}
            onSubmit={onApplyFilters}
            clearFilter={clearFilter}
            kpiTypeOption={kpiTypeOption}
          />

          <div className="bg-white border h-[687px] border-gray-200 w-96 px-6 py-4 overflow-y-auto">
            <KPIList
              kpis={filteredKpis}
              activeKPI={activeKPI}
              onKPIChange={handleKPIChange}
              searchTerm={kpiSearch}
              onSearchChange={setKpiSearch}
            />
          </div>

          <div className="flex-1 h-[687px] border border-gray-200  overflow-y-auto">
            <DetailPanel data={data?.data} />
          </div>
        </div>
      </div>
    ) : (
      <div
        className="flex items-center justify-center"
      >
        <div style={{ textAlign: "center", fontSize: "15px" }}>
          No data available
        </div>
      </div>
    )
  );

};

export default Main;
